import clsx from 'clsx';
import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { formatDateWithDateAndMonthName, getValueFromResource, FormatInvoiceDecimalNumber, formatNumberCustomoriginalapiv2, isTimeEntryHoursFormat, setItemStatus, normalizeDateFormat } from '../../../common/timeLiveFunction';
import moment from 'moment';
import { DateRangePicker } from 'rsuite';
import fetchAPI from '../../../common/fetchAPI';
import { Dropdown } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import TaskList from '../projectTask/TaskList';
import Milestone from '../milestone/MilestoneList';
import ProjectEmailNotificationPreferences from '../emailNotification/ProjectEmailNotificationPreferences';
import AssignedProjectTeam from '../team/AssignedProjectTeam';
import TaskAddAndUpdate from '../projectTask/TaskAddAndUpdate';
import TaskOffCanvas from '../../../common/OffCanvas';
import ProjectAddUpdate from './ProjectAddUpdate';
import MilestoneAddUpdate from '../milestone/MilestoneAddUpdate';
import { resetAttachmentList } from '../../../features/attachment/AttachmentSlice';
import { AttachmentUpload } from '../../../features/attachment/AttachmentUpload';
import GetAttachments from '../../../features/attachment/AttachmentItem';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import Loader from '../../../common/Loader';
import { updateAccountProjectId, updateAccountProjectTaskId, reloadFromMoveTask, updateLoadingState } from '../TasksSlice';
import { updateAccountProjectId as getMethodFromProjectSlice, updateIsLoading, deleteAccountProject, updateProjectAttachment, updateFromProjectSummary } from '../projectSlice';
import { updateAccountProjectId as getMethodFromMilestoneSlice, updateIsCanvasFromMilestone, updateIsCanvasFrom, updateMilestone } from '../MilestoneSlice';
import { getParentChildPagePermissionsAsync, UpdateStateShowAdvanceBoard } from '../../../common/GlobalSlice';
import AccountProjectAttachment from './AccountProjectAttachment';
import Board from '../Board/Board';
import Summary from '../Board/Summary';
import AccountProjectForecast from './forecast/AccountProjectForecast';
import { addMonths, subDays } from 'date-fns';
import DatePickerRanges from '../../../common/DatePickerRanges';
import UpdatedBoard from '../Board/UpdatedBoard';
import { updateEmployeeShowAdvanceBoardAction } from '../Board/BoardSlice';

const initialValues = {
    totalHours: '',
    billableHours: '',
    nonBillableHours: '',
    totalExpense: '',
    billableExpense: '',
    nonBillableExpense: '',
    renderTaskOperations: false,
    isCanvasFor: 'Task',
    ProjectCode: "",
    ProjectName: "",
    StartDate: "",
    Deadline: "",
    ProjectBillingRateTypeId: "",
    Status: ""
}

const initialValuesForPermissions = {
    IsTask: false,
    IsAddTask: false,
    IsEditTask: false,
    IsDeleteTask: false,
    IsMilestone: false,
    IsAddMilestone: false,
    IsEditMilestone: false,
    IsDeleteMilestone: false,
    IsProjectTeam: false,
    IsEditProjectTeam: false,
    // IsTaskTeam: false,
    // IsEditTaskTeam: false,
    permissionList: []
}

const getOneMonthRange = (start: Date) => {
    return {
        start,
        end: subDays(addMonths(start, 1), 1),
    };
};

const AccountProjectSummary = () => {
    const { t } = useTranslation();
    const Parent_SystemSecurityCategoryPageId: string = "31";
    const storedObjectData = localStorage.getItem('objProject');
    const objectData = storedObjectData ? JSON.parse(storedObjectData) : {};
    const initialStart = new Date();
    const { end: initialEnd } = getOneMonthRange(initialStart);
    const [SelectedStartDate, setSelectedStartDate] = useState<Date>(initialStart);
    const [SelectedEndDate, setSelectedEndDate] = useState<Date>(initialEnd);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const fromValue = queryParams.get('from');
    // const location = useLocation();
    // const queryString = location.search;
    // const AccountProjectId = queryString.startsWith('?') ? Number(queryString.substring(1)) : Number(queryString);
    const { AccountProjectId } = useParams();
    // const stateData = location.state;
    // const { IsSummaryFrom } = stateData;
    const [projectSummary, setProjectSummary] = useState<any | ''>(initialValues);
    const [tab, setTab] = useState('');
    const tabRef = useRef<string>('');
    // const { AccountProjectId, ProjectCode, ProjectName, Status, StartDate, Deadline, ProjectBillingRateTypeId, IsSummaryFrom, IsTask, IsMilestone, IsProjectTeam, ChildPermission } = state.obj;
    //local storage work comment
    // const { AccountProjectId, ProjectCode, ProjectName, Status, StartDate, Deadline, ProjectBillingRateTypeId, IsSummaryFrom
    //     //, IsTask, IsMilestone, IsProjectTeam, ChildPermission 
    // } = objectData;
    const { IsSummaryFrom } = objectData;
    const { isReload, accountProjectTaskId, isMoveTask, isTaskReload } = useAppSelector((state) => state.tasks);
    const { isCanvasFromMilestone, accountProjectMilestoneId, isLoadingProjectSummary, isCanvasFrom } = useAppSelector((state) => state.milestone);
    const { cultureInfoName, decimalPlaces, IsEdit, IsDelete, isLoading: isLoading_globalState, timeEntryHoursFormatId, enableUploadFeature, accountFeatureList, CurrentCultureDateFormat, decimalFormat, ShowAdvanceBoard
        //, customMenuList 
    } = useAppSelector((state) => state.globalState);
    const [isRelodProjectSummary, setIsRelodProjectSummary] = useState(true);
    const [childs, setChilds] = useState(initialValuesForPermissions);
    const [isMasterLoading, setIsMasterLoading] = useState(true);
    const [isPermissionsLoaded, setIsPermissionsLoaded] = useState(false);
    const [projectSummaryData, setProjectSummaryData]=useState<any>({ExpenseHours: [],TimeEntryHours: []})
    const showBoard = accountFeatureList?.some((item: any) => item?.Id === 'c255773b-f603-4551-b6c2-880ce664e1e3') ?? false;
    const showForecast = accountFeatureList?.some((item: any) => item?.Id === 'c873be6e-a7a0-4f31-a6d0-c2a05a4f796a') ?? false;
    const showScheduler = accountFeatureList?.some((item: any) => item?.Id === '444fed58-16e0-49a4-8e42-b0e01c5e569b') ?? false;
    const showItems = fromValue === 'projectTemplate'
    const isFirstRenderRef = useRef(true);

    useEffect(() => {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        if (tab === 'Summary') {
            renderAccountProjectSummary();
        }
    }, [tab]);

    useEffect(() => {
        tabRef.current = tab;
    }, [tab]);

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (Parent_SystemSecurityCategoryPageId && Parent_SystemSecurityCategoryPageId !== '') {
                getPermissions(Parent_SystemSecurityCategoryPageId, "32,30,88,158")
            }
        }
        fetchPagePermissions();
    }, [dispatch]);

    const getPermissions = (SystemSecurityCategoryPageId: string, ChildSystemSecurityCategoryPageIds: string) => {
        setIsMasterLoading(true);
        dispatch(getParentChildPagePermissionsAsync({ SystemSecurityCategoryPageId: SystemSecurityCategoryPageId, ChildSystemSecurityCategoryPageIds: ChildSystemSecurityCategoryPageIds }))
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.ParentPermission) {
                    if (originalPromiseResult.ParentPermission.IsList && originalPromiseResult.ChildPermission) {
                        const childPermission: any = originalPromiseResult.ChildPermission;
                        const isTask = childPermission.filter((x: any) => x.Id === 32)[0].IsList;
                        const isAddTask = childPermission.filter((x: any) => x.Id === 32)[0].IsAdd;
                        const isEditTask = childPermission.filter((x: any) => x.Id === 32)[0].IsEdit;
                        const isDeleteTask = childPermission.filter((x: any) => x.Id === 32)[0].IsDelete;
                        const isMilestone = childPermission.filter((x: any) => x.Id === 30)[0].IsList;
                        const isAddMilestone = childPermission.filter((x: any) => x.Id === 30)[0].IsAdd;
                        const isEditMilestone = childPermission.filter((x: any) => x.Id === 30)[0].IsEdit;
                        const isDeleteMilestone = childPermission.filter((x: any) => x.Id === 30)[0].IsDelete;
                        const isProjectTeam = childPermission.filter((x: any) => x.Id === 88)[0].IsList;
                        const isEditProjectTeam = childPermission.filter((x: any) => x.Id === 88)[0].IsEdit;
                        // const isTaskTeam = childPermission.filter((x: any) => x.Id === 158)[0].IsList;
                        // const isEditTaskTeam = childPermission.filter((x: any) => x.Id === 158)[0].IsEdit;
                        setChilds({
                            ...childs,
                            IsTask: isTask,
                            IsAddTask: isAddTask,
                            IsEditTask: isEditTask,
                            IsDeleteTask: isDeleteTask,
                            IsMilestone: isMilestone,
                            IsAddMilestone: isAddMilestone,
                            IsEditMilestone: isEditMilestone,
                            IsDeleteMilestone: isDeleteMilestone,
                            IsProjectTeam: isProjectTeam,
                            IsEditProjectTeam: isEditProjectTeam,
                            // IsTaskTeam: isTaskTeam,
                            // IsEditTaskTeam: isEditTaskTeam
                        });
                        dispatch(updateAccountProjectId(AccountProjectId));
                        renderAccountProjectSummary();

                        if (IsSummaryFrom === 'View' && !showItems) {
                            setTab('Summary');
                        } else if (IsSummaryFrom === 'View' && isTask) {
                            setTab('TaskList');
                        } else if (IsSummaryFrom === 'View' && !isTask && isMilestone) {
                            setTab('MilestoneList');
                        } else if (IsSummaryFrom === 'View' && !isTask && !isMilestone && isProjectTeam) {
                            setTab('TeamList');
                        } else if (IsSummaryFrom === 'View' && !isTask && !isMilestone && !isProjectTeam) {
                            setTab('AttachmentList');
                        } else if (IsSummaryFrom === 'Task') {
                            setTab('TaskList');
                        }
                        else if (IsSummaryFrom === 'Milestone') {
                            setTab('MilestoneList');
                        }
                    }
                    else {
                        navigate('../error/403');
                    }
                }
                else {
                    navigate('../error/403');
                }
            })
            .catch((rejectedValueOrSerializedError) => {
            })
            .finally(() => {
                setIsMasterLoading(false);
                setIsPermissionsLoaded(true);
            });
    }
    const modelAttachmentRef = useRef<any>(null);

    // //Attachment Work
    // const modalAttachmentRef = useRef<any>(null);
    // const [tempAttachmentId, setTempAttachmentId] = useState(null);
    // const [modalIsOpen, setModalIsOpen] = useState(false);
    // const attachmentUploadClearRef = useRef<any>(null);
    // useEffect(() => {
    //     if (modalIsOpen) {
    //         if (modalAttachmentRef.current) {
    //             modalAttachmentRef.current.click();
    //         }
    //     }
    // }, [modalIsOpen]);
    // const handleAttachment = () => {
    //     dispatch(resetAttachmentList());
    //     setModalIsOpen(true);
    // }
    // const updateTempAttachmentId = (value: any) => {
    //     setTempAttachmentId(value);
    // };
    // //Attachment Work

    // useLayoutEffect(() => {
    //     if (isRelodProjectSummary) {
    //         dispatch(getCustomPagePermissionsAsync("32,30,88,158")).then(() => {
    //             setIsRelodProjectSummary(false);
    //         }).catch()
    //     }
    // }, [isRelodProjectSummary]);

    useEffect(() => {
        //if (isReload) {
        dispatch(updateAccountProjectId(AccountProjectId))
        renderAccountProjectSummary();
        if (isTaskReload) {
            // setTab('TaskList');
            if (tabRef.current !== 'Board') {
                setTab('TaskList');
            }
            dispatch(updateLoadingState(false));
            return;
        }
         if (isMoveTask) {
            setTab('TaskList');
            return;
        } 
        if (tabRef.current !== '') {
            return;
        }
        if (IsSummaryFrom === 'View' && !showItems) {
            setTab('Summary');
        } else if (IsSummaryFrom === 'View' && childs.IsTask) {
            setTab('TaskList');
        } else if (IsSummaryFrom === 'View' && !childs.IsTask && childs.IsMilestone) {
            setTab('MilestoneList');
        } else if (IsSummaryFrom === 'View' && !childs.IsTask && !childs.IsMilestone && childs.IsProjectTeam) {
            setTab('TeamList');
        } else if (IsSummaryFrom === 'View' && !childs.IsTask && !childs.IsMilestone && !childs.IsProjectTeam) {
            setTab('AttachmentList');
        } else if (IsSummaryFrom === 'Task') {
            setTab('TaskList');
        }
        else if (IsSummaryFrom === 'Milestone') {
            setTab('MilestoneList');
        }
        // else {
        // }
        // if (IsSummaryFrom === 'View' || IsSummaryFrom === 'Task') {
        //     setTab('TaskList');
        // } else if (IsSummaryFrom === 'Milestone') {
        //     setTab('MilestoneList');
        // }
        //}
    }, [isReload, AccountProjectId, timeEntryHoursFormatId, isTaskReload]);

    const renderAccountProjectSummary = async () => {
        if (timeEntryHoursFormatId) {
            setIsMasterLoading(true);
            try {
                const response = await fetchAPI(`api/V2/Projects/GetAccountProjectSummary/${AccountProjectId}/${isTimeEntryHoursFormat(timeEntryHoursFormatId)}`, 'Get', '', true);
                const json = await response.json();
                let totalHours = json["TimeEntryHours"][0];
                let expenseHours = json["ExpenseHours"][0];
                let accountProject = json["AccountProject"][0];
                setProjectSummaryData({
                    ExpenseHours:   json["ExpenseHours"][0],
                    TimeEntryHours: json["TimeEntryHours"][0]
                })
                setProjectSummary({
                    ...projectSummary,
                    totalHours: totalHours != undefined ? decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), totalHours.ConvertTotalMinutes, 2) : totalHours.ConvertTotalMinutes : decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, 2) : Number(0).toFixed(2),
                    billableHours: totalHours != undefined ? decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), totalHours.ConvertBillableTotalMinutes, 2) : totalHours.ConvertBillableTotalMinutes : decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, 2) : Number(0).toFixed(2),
                    nonBillableHours: totalHours != undefined ? decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), totalHours.ConvertNonBillableTotalMinutes, 2) : totalHours.ConvertNonBillableTotalMinutes : decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, 2) : Number(0).toFixed(2),
                    totalExpense: expenseHours != undefined ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), expenseHours.Amount, decimalPlaces) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, decimalPlaces),
                    billableExpense: expenseHours != undefined ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), expenseHours.billableamount, decimalPlaces) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, decimalPlaces),
                    nonBillableExpense: expenseHours != undefined ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), expenseHours.Nonbillableamount, decimalPlaces) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, decimalPlaces),
                    ProjectCode: accountProject.ProjectCode,
                    ProjectName: accountProject.ProjectName,
                    StartDate: accountProject.StartDate,
                    Deadline: accountProject.Deadline,
                    ProjectBillingRateTypeId: accountProject.ProjectBillingRateTypeId
                });
                if (isMoveTask) {
                    dispatch(reloadFromMoveTask());
                }
            } catch (error) {

            } finally {
                setIsMasterLoading(false);
            }
        }
    }

    const handleDateRangeChange = (value: [Date | null, Date | null] | null) => {
        if (value && value[0] && value[1]) {
            const startDate = value[0];
            const endDate = value[1];
            const twoMonthsLater = addMonths(startDate, 2);
            const maxAllowedEndDate = subDays(twoMonthsLater, 1);

            if (endDate > maxAllowedEndDate) {
                ShowToast('Error', 'Please select a date range of maximum 2 months', "error", "toast-top-right");
                return;
            }

            setSelectedStartDate(value[0]);
            setSelectedEndDate(value[1]);
        }
    };

    const shiftDateRange = (type: "previous" | "next") => {
        const diff = type === "previous" ? -1 : 1;
        const start = new Date(SelectedStartDate);
        const end = new Date(SelectedEndDate);
        start.setMonth(start.getMonth() + diff);
        end.setMonth(end.getMonth() + diff);
        setSelectedStartDate(start);
        setSelectedEndDate(end);
    };

    const onDeleteProject = (id: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(updateIsLoading(true));
                    dispatch(deleteAccountProject(id)).then((result) => {
                        Number(result.payload.Id) > 0 && navigate('/projects');
                        Number(result.payload.Id) > 0 ?
                            ShowToast('Success', 'Project Delete Successfully!', "success", "toast-top-right") :
                            ShowToast('Error', 'Project Delete Failed!', "error", "toast-top-right");
                    }).catch((error) => {
                    })
                }
            })
            .catch((error) => {
            });
    }

    const navigateToProjectTeam = (obj: any) => {
        if (fromValue === 'projectTemplate') {
            navigate(`/projectteam/${AccountProjectId}?from=templateTeam`, { state: { obj } })
        } else {
            navigate(`/projectteam/${AccountProjectId}`, { state: { obj } })
        }
    }

    // const generalObject = {
    //     "name": isCanvasFromMilestone ? t("Milestone") : 
    //                                     projectSummary.isCanvasFor === 'Task' ? t("Task") : 
    //                                     projectSummary.isCanvasFor === 'Milestone' ? t("Milestone") : 
    //                                     t("Project"),
    //     "width": "700px",
    //     "componentName": isCanvasFromMilestone ? <MilestoneAddUpdate IsFromSummary={true} /> : 
    //                                     projectSummary.isCanvasFor === 'Task' ? <TaskAddAndUpdate AccountProjectId={AccountProjectId} /> :
    //                                     projectSummary.isCanvasFor === 'Milestone' ? <MilestoneAddUpdate IsFromSummary={true} /> :
    //                                     <ProjectAddUpdate IsFromSummary={true} 
    //                                     />
    // }

    // const generalObject = {
    //     "name": isCanvasFrom === 'Milestone' ? t("Milestone") :
    //         isCanvasFrom === 'Task' ? t("Task") :

    //             isCanvasFrom === 'Project' ? t(" Update Project") :
    //                 t("Project"),
    //     "width": "700px",
    //     "componentName": isCanvasFrom === 'Milestone' ? <MilestoneAddUpdate IsFromSummary={true} /> :
    //         isCanvasFrom === 'Task' ? <TaskAddAndUpdate AccountProjectId={AccountProjectId} /> :
    //             isCanvasFrom === 'Project' ? <ProjectAddUpdate IsFromSummary={true} /> :
    //                 <ProjectAddUpdate IsFromSummary={true}
    //                 />
    // }

    const generalObject = {
        "name": isCanvasFrom === 'Milestone' ? (accountProjectMilestoneId === 0 ? getValueFromResource("Add Milestone", dispatch, t) : getValueFromResource("Update Milestone", dispatch, t)) :
            isCanvasFrom === 'Task' ? (accountProjectTaskId === 0 ? getValueFromResource("Add Task", dispatch, t) : getValueFromResource("Update Task", dispatch, t)) :
                isCanvasFrom === 'Project' ? getValueFromResource("Update Project", dispatch, t) :
                    getValueFromResource("Project", dispatch, t),
        "width": "700px",
        "componentName": isCanvasFrom === 'Milestone' ? <MilestoneAddUpdate AccountProjectId={AccountProjectId} /> :
            isCanvasFrom === 'Task' ? <TaskAddAndUpdate AccountProjectId={AccountProjectId} /> :
                isCanvasFrom === 'Project' ? <ProjectAddUpdate IsFromSummary={true} /> :
                    <ProjectAddUpdate IsFromSummary={true} />
    }
    let obj = {
        "ProjectCode": projectSummary.ProjectCode,
        "ProjectName": projectSummary.ProjectName,
        "Status": projectSummary.Status,
        "StartDate": projectSummary.StartDate,
        "Deadline": projectSummary.Deadline,
        "ProjectBillingRateTypeId": projectSummary.ProjectBillingRateTypeId,
        "IsEditTask": childs.IsEditTask,
        "IsDeleteTask": childs.IsDeleteTask
    }

    const onClickAttachmentEvent = () => {
        dispatch(resetAttachmentList());
        modelAttachmentRef.current.click();
        dispatch(updateProjectAttachment(true));
    }


    const navigateToAudit = (AccountProjectId: any) => {
        const obj = {
            Id: AccountProjectId,
            TableName: 'AccountProject',
            Title: getValueFromResource('Project Audit', dispatch, t)
        }
        navigate(`/accountaudit/${AccountProjectId}`, { state: { obj } });
    };

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
        .custom-date-range-picker .rs-picker-toggle-value {
          white-space: nowrap !important;
          overflow: visible !important;
          text-overflow: unset !important;
          color: #172b4d !important;
         font-weight: 600 !important;
        }
        .custom-date-range-picker .rs-picker-toggle {
          width: auto !important;
          min-width: fit-content !important;
          padding-right: 8px !important;
          padding-left: 8px !important;
          padding-bottom: 6px !important;
          padding-top: 6px !important;
        }
        .custom-date-range-picker .rs-picker-toggle-caret {
          display: none !important;
        }
        .custom-date-range-picker .rs-picker-toggle,
        .custom-date-range-picker .rs-picker-toggle:focus,
        .custom-date-range-picker .rs-picker-toggle:active,
        .custom-date-range-picker .rs-picker-toggle:focus-visible {
          border-color: transparent !important;
          box-shadow: none !important;
          outline: none !important;
          background-color: transparent !important;
          color: #172b4d !important;
         font-weight: 600 !important;
        }
         .custom-date-range-picker .rs-picker-toggle-caret {
          display: none !important;
        }
        .custom-date-range-picker .rs-picker-toggle-clean {
          display: none !important;
        }
        .custom-date-range-picker {
          display: flex;
          align-items: center;
        }
        .card-header.dropdown-zindex {
          z-index: 99 !important;
        }
        .dropdown-menu.show {
          z-index: 99 !important;
        }
      `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    return (
        <>
            {/* {modalIsOpen && (
                <>
                    <div className="modal fade" tabIndex={-1} id="attachmentModel" data-bs-backdrop="static">
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content rounded">
                                <div className='modal-header pb-2'>
                                    <h6>{t(`Attachment`)}</h6>
                                    <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal' onClick={() => setModalIsOpen(false)}>
                                        <KTIcon iconName='cross' className='fs-1' />
                                    </div>
                                </div>
                                <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                                    <AttachmentUpload
                                        Id={Number(AccountProjectId)}
                                        onupdateTempAttachmentId={updateTempAttachmentId}
                                        clearRef={attachmentUploadClearRef}
                                        AccountAttachmentTypeId={4}
                                    />
                                    <GetAttachments Id={Number(AccountProjectId)} AccountAttachmentTypeId={4} IsShowEmployeeInformation={false} />
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        data-bs-dismiss="modal"
                                        onClick={() => setModalIsOpen(false)}
                                    >{t("Close")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button ref={modalAttachmentRef} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#attachmentModel">
                        {t('Launch demo modal')}
                    </button>
                </>
            )} */}
            {/* {isLoadingProjectSummary || isLoading_globalState && <Loader />} */}
            {(isMasterLoading || !isPermissionsLoaded) && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white dropdown-zindex fixed-top">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Project Detail')} */}
                        {getValueFromResource('Project Detail', dispatch, t)}
                    </h3>
                    <div className="card-toolbar align-items-center">
                        {tab === 'Board' && <div className="form-check form-switch form-check-custom form-check-solid me-2">
                            <label className="fs-7 fw-normal" style={{ marginRight: 5 }}>
                                {getValueFromResource("Show Advanced", dispatch, t)}
                            </label>
                            <input
                                type="checkbox"
                                checked={ShowAdvanceBoard}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    const newValue = e.target.checked;
                                    dispatch(UpdateStateShowAdvanceBoard(newValue));
                                    dispatch(updateEmployeeShowAdvanceBoardAction({ ShowAdvanceBoard: newValue }));
                                }}
                                // onChange={(e) => dispatch(UpdateStateShowAdvanceBoard(e.target.checked))}
                                className="form-check-input h-20px w-40px"
                            />
                        </div>}
                        <div className="btn-group me-2">
                            <button
                                type="button"
                                className="btn btn-primary btn-bs-btn-font-weight btn-sm dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <i className="fa fa-plus mb-1 me-1"></i>
                                {/* {t('Add')} */}
                                {getValueFromResource('Add ', dispatch, t)}
                                <i className=""></i>
                                <i className="fa fa-angle-down"></i>
                            </button>
                            <ul className="dropdown-menu menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-175px" role="menu">
                                <div className='menu-hover-bg-sec cursor'>
                                    {childs.IsAddTask &&
                                        <Dropdown.Item
                                            id="kt_OffCanvas"
                                            className="menu-item me-lg-0 custom-menu-item"
                                            onClick={() => {                                                
                                                dispatch(updateIsCanvasFrom('Task'));
                                                dispatch(updateAccountProjectTaskId(0));
                                                
                                                setProjectSummary({
                                                    ...projectSummary,
                                                    isCanvasFor: getValueFromResource('Add Task', dispatch, t)
                                                });
                                            }}
                                        >
                                            <span className="menu-icon custom-menu mb-2">
                                                <i className="bi bi-file-earmark-text fs-6 iconColor">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                            <span className="menu-title custom-menu-fontsize">
                                                {/* {`${t('Add Task')}`} */}
                                                {getValueFromResource('Add Task', dispatch, t)}
                                            </span>
                                        </Dropdown.Item>
                                    }
                                    {childs.IsEditProjectTeam && <Dropdown.Item
                                        className="menu-item me-lg-0 custom-menu-item"
                                        onClick={() => {
                                            navigateToProjectTeam({
                                                "AccountProjectId": AccountProjectId,
                                                "ProjectCode": projectSummary.ProjectCode,
                                                "ProjectName": projectSummary.ProjectName,
                                                "Status": projectSummary.Status,
                                                "StartDate": projectSummary.StartDate,
                                                "Deadline": projectSummary.Deadline,
                                                "ProjectBillingRateTypeId": projectSummary.ProjectBillingRateTypeId
                                            })
                                        }}
                                    >
                                        <span className="menu-icon custom-menu mb-2">
                                            <i className="bi bi-person-plus fs-4 iconColor">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                        <span className="menu-title custom-menu-fontsize">
                                            {/* {`${t('Add Team')}`} */}
                                            {getValueFromResource('Add Team', dispatch, t)}

                                        </span>
                                    </Dropdown.Item>}
                                    {projectSummary.ProjectBillingRateTypeId === 2 &&
                                        <Dropdown.Item
                                            id="kt_OffCanvas"
                                            className="menu-item me-lg-0 custom-menu-item"
                                            onClick={() => {
                                                navigate('/accountprojectrole', {
                                                    state: {
                                                        "AccountProjectId": AccountProjectId,
                                                        "ProjectCode": projectSummary.ProjectCode,
                                                        "ProjectName": projectSummary.ProjectName,
                                                        "AccountWorkTypeId": 0,
                                                        "Status": projectSummary.Status,
                                                        "StartDate": projectSummary.StartDate,
                                                        "Deadline": projectSummary.Deadline
                                                    }
                                                });
                                            }}
                                        >
                                            <span className="menu-icon custom-menu mb-2">
                                                <i className="bi bi-people fs-4 iconColor">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                            <span className="menu-title custom-menu-fontsize">
                                                {/* {`${t('Role Wise Billing Rate')}`} */}
                                                {getValueFromResource('Role Wise Billing Rate', dispatch, t)}

                                            </span>
                                        </Dropdown.Item>}
                                    {childs.IsAddMilestone &&
                                        <Dropdown.Item
                                            id="kt_OffCanvas"
                                            className="menu-item me-lg-0 custom-menu-item"
                                            onClick={() => {
                                                dispatch(updateIsCanvasFrom('Milestone'));
                                                dispatch(getMethodFromMilestoneSlice(AccountProjectId));
                                                dispatch(updateMilestone({
                                                    "accountProjectMilestoneId": 0,
                                                    "isCanvasFromMilestone": true
                                                }))
                                                setProjectSummary({
                                                    ...projectSummary,
                                                    isCanvasFor: 'Milestone'
                                                });
                                            }}
                                        >
                                            <span className="menu-icon custom-menu mb-2">
                                                <i className="bi bi-flag fs-6 iconColor">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                                {/* <i className="bi bi-file-earmark-text fs-6 iconColor">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i> */}
                                            </span>
                                            <span className="menu-title custom-menu-fontsize">
                                                {/* {`${t('Add Milestone')}`} */}
                                                {getValueFromResource('Add Milestone', dispatch, t)}
                                            </span>
                                        </Dropdown.Item>
                                    }
                                    {enableUploadFeature &&
                                        <Dropdown.Item
                                            className="menu-item me-lg-0 custom-menu-item"
                                            onClick={(event: any) => {
                                                event.preventDefault();
                                                //handleAttachment();
                                                onClickAttachmentEvent()
                                            }}
                                        >
                                            {/* <span className="menu-icon custom-menu mb-2">
                                            <i className="bi bi-paperclip fs-4 iconColor">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span> */}
                                            <span
                                                ref={modelAttachmentRef}
                                                data-bs-toggle="modal"
                                                data-bs-target="#attachmentModel"
                                                className="menu-icon custom-menu mb-2"
                                            >
                                                <i className="bi bi-paperclip fs-4 iconColor">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                            <span className="menu-title custom-menu-fontsize">
                                                {/* {`${t('Add Attachment')}`} */}
                                                {getValueFromResource('Add Attachment', dispatch, t)}
                                            </span>
                                        </Dropdown.Item>
                                    }
                                </div>
                            </ul>
                        </div>
                        <div className="btn-group">
                            <button
                                type="button"
                                className="btn btn-secondary btn-bs-btn-font-weight btn-sm dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <i className="fa fa-cog mb-1 me-1"></i>
                                {/* {t('Options')} */}
                                {getValueFromResource('Options', dispatch, t)}
                                <i className=""></i>
                                <i className="fa fa-angle-down"></i>
                            </button>
                            <ul className="dropdown-menu menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-175px" role="menu">
                                <div className='menu-hover-bg-sec'>
                                    {IsEdit && <Dropdown.Item
                                        id="kt_OffCanvas"
                                        className="menu-item me-lg-0"
                                        onClick={() => {
                                            //isCanvasFromMilestone && dispatch(updateIsCanvasFromMilestone(false));
                                            dispatch(updateIsCanvasFrom('Project'));
                                            dispatch(getMethodFromProjectSlice(AccountProjectId))
                                            dispatch(updateFromProjectSummary());
                                            setProjectSummary({
                                                ...projectSummary,
                                                isCanvasFor: getValueFromResource('Project', dispatch, t)
                                            });
                                        }}
                                    >
                                        <span className="menu-icon custom-menu mb-2">
                                            <i className="bi bi-pencil-square fs-6 iconColor allign ">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                        <span className="menu-title custom-menu-fontsize">
                                            {/* {`${t('Edit Project')}`} */}
                                            {getValueFromResource('Edit Project', dispatch, t)}
                                        </span>
                                    </Dropdown.Item>
                                    }
                                    {!showItems && <Dropdown.Item
                                        className="menu-item me-lg-0 "
                                        onClick={() => navigateToAudit(AccountProjectId)}
                                    >
                                        <span className="menu-icon custom-menu mb-2">
                                            <i className="bi bi-receipt fs-6 iconColor">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                        <span className="menu-title custom-menu-fontsize">
                                            {/* {`${t('Audit')}`} */}
                                            {getValueFromResource('Audit', dispatch, t)}
                                        </span>
                                    </Dropdown.Item>}
                                </div>
                                {IsDelete &&
                                    <>
                                        <div className='separator mb-1 mt-1 opacity-75'></div>
                                        <div className='menu-hover-bg-danger'>
                                            <Dropdown.Item
                                                className="menu-item me-lg-0"
                                                onClick={() => { onDeleteProject(Number(AccountProjectId)) }}
                                            >
                                                <span className="menu-icon custom-menu mb-2">
                                                    <i className="bi bi-trash fs-6 delete-menu-icon-color allign">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                <span className="menu-title delete-menu custom-menu-fontsize">
                                                    {/* {`${t('Delete')}`} */}
                                                    {getValueFromResource('Delete', dispatch, t)}
                                                </span>
                                            </Dropdown.Item>
                                        </div>
                                    </>
                                }

                            </ul>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className='mt-4'>
                                <div className="d-flex align-items-center mt-2 mb-2">
                                    <a className="text-muted fw-bold me-2 fs-2">{projectSummary.ProjectName}</a>
                                </div>
                                <div className="d-flex flex-wrap fs-7 mb-4 pe-2">
                                    <a className="text-gray-500">
                                        <i className="bi bi-calendar fs-6 iconColor me-2"></i>
                                        {/* {`${moment.parseZone(projectSummary.StartDate).format('DD MMM yy')} - ${moment.parseZone(projectSummary.Deadline).format('DD MMM yy')}`} */}
                                        {formatDateWithDateAndMonthName(projectSummary.StartDate, cultureInfoName.toString())} - {formatDateWithDateAndMonthName(projectSummary.Deadline, cultureInfoName.toString())}
                                    </a>
                                    <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(projectSummary.Status))} style={{ lineHeight: 0.8, marginLeft: 4 }}>
                                        {projectSummary.Status}
                                    </span>
                                </div>
                            </div>
                            {tab === 'Forecast' && <div className="d-flex align-items-center flex-shrink-0" style={{ position: 'relative', backgroundColor: 'white', border: '1px solid rgba(0, 0, 0, 0.1)', borderRadius: '4px', height: '36px' }}>
                                <a onClick={() => shiftDateRange("previous")} className="btn btn-sm btn-icon btn-icon-primary"><i className="ki-outline ki-left fs-3"></i></a>
                                <DateRangePicker
                                    value={[SelectedStartDate, SelectedEndDate]}
                                    onChange={handleDateRangeChange}
                                    // ranges={DatePickerRanges()}
                                    ranges={[]}
                                    style={{ width: 'auto' }}
                                    className="custom-date-range-picker"
                                    appearance="subtle"
                                    placement="bottomEnd"
                                    format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                                    // format="MMM dd, yyyy"
                                    cleanable={false}
                                    editable={false}
                                />
                                <a onClick={() => shiftDateRange("next")} className="btn btn-sm btn-icon btn-icon-primary"><i className="ki-outline ki-right fs-3"></i></a>
                            </div>}
                        </div>
                        <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap mt-6' role='tablist'>
                            {!showItems && <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Summary' })}
                                    onClick={() => setTab('Summary')}
                                    role='tab'
                                >
                                    {getValueFromResource('Summary', dispatch, t)}
                                </a>
                            </li>}
                            {childs.IsTask && <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'TaskList' })}
                                    onClick={() => setTab('TaskList')}
                                    role='tab'
                                >
                                    {/* {t("Task")} */}
                                    {getValueFromResource('Task', dispatch, t)}
                                </a>
                            </li>}
                            {childs.IsMilestone && <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'MilestoneList' })}
                                    onClick={() => setTab('MilestoneList')}
                                    role='tab'
                                >
                                    {/* {t("Milestone")} */}
                                    {getValueFromResource('Milestone', dispatch, t)}
                                </a>
                            </li>}
                            {childs.IsProjectTeam && <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'TeamList' })}
                                    onClick={() => setTab('TeamList')}
                                    role='tab'
                                >
                                    {/* {t("Team")} */}
                                    {getValueFromResource('Team', dispatch, t)}
                                </a>
                            </li>}
                            {(!showItems && childs.IsTask && showBoard) && <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Board' })}
                                    onClick={() => setTab('Board')}
                                    role='tab'
                                >
                                    {getValueFromResource('Board', dispatch, t)} <span className="badge badge-sm badge-light-primary ms-1 mb-2 d-inline-flex align-items-center justify-content-center" style={{ fontSize: '8px', lineHeight: '1', padding: '4px 6px' }}>NEW</span>

                                </a>
                            </li>}
                            {(!showItems && showForecast && showScheduler) && <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Forecast' })}
                                    onClick={() => setTab('Forecast')}
                                    role='tab'
                                >
                                    {getValueFromResource('Forecast', dispatch, t)} <span className="badge badge-sm badge-light-primary ms-1 mb-2 d-inline-flex align-items-center justify-content-center" style={{ fontSize: '8px', lineHeight: '1', padding: '4px 6px' }}>NEW</span>
                                </a>
                            </li>}
                            <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'AttachmentList' })}
                                    onClick={() => setTab('AttachmentList')}
                                    role='tab'
                                >
                                    {/* {t("Attachment")} */}
                                    {getValueFromResource('Attachment', dispatch, t)}
                                </a>
                            </li>
                            <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'PreferencesList' })}
                                    onClick={() => setTab('PreferencesList')}
                                    role='tab'
                                >
                                    {/* {t("Email Preferences")} */}
                                    {getValueFromResource('Email Preferences', dispatch, t)}
                                </a>
                            </li>


                        </ul>
                        <div className='tab-content pt-0'>
                            {childs.IsTask && <div className={clsx('tab-pane', { active: tab === 'TaskList' })}>
                                {/* {tab === 'TaskList' && <TaskList obj={obj} permissions={ChildPermission.filter((x: any) => x.Id == 32)[0]} />} */}
                                {tab === 'TaskList' && <TaskList obj={obj} />}
                            </div>}
                            {childs.IsMilestone && <div className={clsx('tab-pane', { active: tab === 'MilestoneList' })}>
                                {tab === 'MilestoneList' && <Milestone AccountProjectId={AccountProjectId} IsEditMilestone={childs.IsEditMilestone} IsDeleteMilestone={childs.IsDeleteMilestone} />}
                            </div>}
                            {childs.IsProjectTeam && <div className={clsx('tab-pane', { active: tab === 'TeamList' })}>
                                {tab === 'TeamList' && <AssignedProjectTeam />}
                            </div>}
                            <div className={clsx('tab-pane', { active: tab === 'AttachmentList' })}>
                                {tab === 'AttachmentList' && <GetAttachments Id={Number(AccountProjectId)} AccountAttachmentTypeId={4} IsShowEmployeeInformation={false} />}
                            </div>
                            <div className={clsx('tab-pane', { active: tab === 'PreferencesList' })}>
                                {tab === 'PreferencesList' && <ProjectEmailNotificationPreferences AccountProjectId={AccountProjectId} />}
                            </div>
                            {childs.IsTask && <div className={clsx('tab-pane', { active: tab === 'Board' })}>
                                {tab === 'Board' && <UpdatedBoard AccountProjectId={AccountProjectId} obj={obj} isAddTask={childs?.IsAddTask} permission={childs} showAdvance={ShowAdvanceBoard} />}
                                {/* {tab === 'Board' && <Board AccountProjectId={AccountProjectId} obj={obj} isAddTask={childs?.IsAddTask}  permission={childs}/>} */}
                            </div>}
                            <div className={clsx('tab-pane', { active: tab === 'Forecast' })}>
                                {tab === 'Forecast' && <AccountProjectForecast AccountProjectId={AccountProjectId} startDate={SelectedStartDate} endDate={SelectedEndDate} />}
                            </div>
                            <div className={clsx('tab-pane', { active: tab === 'Summary' })}>
                                {tab === 'Summary' && <Summary projectSummary={projectSummary} AccountProjectId={AccountProjectId} isParentLoading={isMasterLoading} projectSummaryData={projectSummaryData}/>}
                            </div>
                        </div>
                    </div>
                    <div className='col-md-3' style={{ display: 'none' }}>
                        <div className="d-flex align-items-center mt-3 mb-3">
                            <a className="text-muted fs-6 fw-bold me-2">
                                {/* {t('Project Summary')} */}
                                {getValueFromResource('Project Summary', dispatch, t)}
                            </a>
                        </div>
                        <div className='col-md-12 col-sm-12 col-xs-12'>
                            <div className='cardInfoShadow' style={{ height: 132 }}>
                                <div className='tsNavBarInnerBoxParent'>
                                    <div className='tsNavBarInnerBoxSecondSection' style={{ left: 8, top: 10 }}>
                                        <span className="fw-bold d-block fs-3 tsNavBarInfoText">{projectSummary.totalHours}</span>
                                        <a className="text-uppercase tsNavBarInfoLabel">
                                            {/* {t('Total Hours')} */}
                                            {getValueFromResource('Total Hours', dispatch, t)}
                                        </a>
                                    </div>
                                </div>
                                <div className='row mt-10'>
                                    <div className='col-md-6'>
                                        <span className="fw-bold d-block fs-3 tsNavBarInfoText" style={{ marginLeft: 8 }}>{projectSummary.billableHours}</span>
                                    </div>

                                    <div className='col-md-6'>
                                        <span className="fw-bold d-block fs-3 tsNavBarInfoText">{projectSummary.nonBillableHours}</span>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <span className="text-uppercase tsNavBarInfoLabel" style={{ marginLeft: 8 }}>
                                            {/* {t('Billable Hours')} */}
                                            {getValueFromResource('Billable Hours', dispatch, t)}
                                        </span>
                                    </div>
                                    <div className='col-md-6'>
                                        <span className="text-uppercase tsNavBarInfoLabel">
                                            {/* {t('Non Billable Hours')} */}
                                            {getValueFromResource('Non Billable Hours', dispatch, t)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className='cardInfoShadow mt-3' style={{ height: 132 }}>
                                <div className='tsNavBarInnerBoxParent'>
                                    <div className='tsNavBarInnerBoxSecondSection' style={{ left: 8, top: 10 }}>
                                        <span className="fw-bold d-block fs-3 tsNavBarInfoText">{projectSummary.totalExpense}</span>
                                        <a className="text-uppercase tsNavBarInfoLabel">
                                            {/* {t('TOTAL EXPENSES')} */}
                                            {getValueFromResource('TOTAL EXPENSES', dispatch, t)}
                                        </a>
                                    </div>
                                </div>
                                <div className='row mt-10'>
                                    <div className='col-md-6'>
                                        <span className="fw-bold d-block fs-3 tsNavBarInfoText me-8" style={{ marginLeft: 8 }}>{projectSummary.billableExpense}</span>
                                    </div>

                                    <div className='col-md-6'>
                                        <span className="fw-bold d-block fs-3 tsNavBarInfoText">{projectSummary.nonBillableExpense}</span>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <span className="text-uppercase tsNavBarInfoLabel" style={{ marginLeft: 8 }}>
                                            {/* {t('BILLABLE EXPENSES')} */}
                                            {getValueFromResource('BILLABLE EXPENSES', dispatch, t)}
                                        </span>
                                    </div>
                                    <div className='col-md-6'>
                                        <span className="text-uppercase tsNavBarInfoLabel">
                                            {/* {t('NON BILLABLE EXPENSES')} */}
                                            {getValueFromResource('NON BILLABLE EXPENSES', dispatch, t)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <TaskOffCanvas obj={generalObject} />
            <AccountProjectAttachment modelRef={modelAttachmentRef} accountProjectId={AccountProjectId} />
        </>
    )
}

export default AccountProjectSummary